import React from 'react';
import { useStaticQuery, graphql, Link } from 'gatsby';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import breakpoints from '@repo/ui-components/breakpoints';
import PageWrapper from '@repo/ui-components/page-wrapper/PageWrapper';
import styles from '@utils/styles';

const Heading = styled.h2`
  font-weight: ${styles.fontWeight.medium};
  margin-bottom: 1rem;
`;

const InnerContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 1.5rem;

  @media screen and (min-width: ${breakpoints.lg}) {
    grid-template-columns: ${({ grid }) =>
      `${[...Array(grid)].map(() => '1fr').join(' ')}`};
  }
`;

const CollectionContainer = styled.div`
  min-height: 100px;

  @media screen and (min-width: ${breakpoints.lg}) {
    padding: 0;
  }

  p {
    text-align: center;
    color: ${styles.colors.gray[700]};
    font-weight: ${styles.fontWeight.medium};
    transition: all 0.5s ease;
    margin: 0.5rem 0 0.75rem;

    &:hover {
      color: ${styles.colors.orange[500]};
    }
  }

  .grow {
    transition: all 0.2s ease-in-out;
    overflow: hidden;
  }
  .grow:hover {
    transform: scale(1.05);
  }
  .grow-overflow {
    overflow: hidden;

    img {
      width: 100%;
    }
  }
`;

const CollectionList = ({ items, settings }) => {
  const data = useStaticQuery(graphql`
    query shopifyCollections {
      allCollections: allShopifyCollection {
        nodes {
          handle
          title
          image {
            src
          }
        }
      }
    }
  `);
  const { nodes } = data.allCollections;
  const filteredCollections = items.map(item =>
    nodes.find(node => node.handle === item)
  );
  return (
    <PageWrapper>
      {settings?.title && <Heading>{settings.title}</Heading>}
      <InnerContainer grid={settings.grid}>
        {filteredCollections.map(collection => (
          <CollectionContainer key={collection.title}>
            <Link to={`/${collection.handle}`}>
              <div className="grow-overflow">
                {collection?.image?.src && (
                  <img
                    src={`${collection.image.src}&width=400`}
                    alt={`${collection.title} Collection`}
                  />
                )}
              </div>
              <p>{collection.title}</p>
            </Link>
          </CollectionContainer>
        ))}
      </InnerContainer>
    </PageWrapper>
  );
};

CollectionList.propTypes = {
  items: PropTypes.arrayOf(PropTypes.string).isRequired,
  settings: PropTypes.shape({
    title: PropTypes.string,
    grid: PropTypes.number,
  }).isRequired,
};

export default CollectionList;
